import { render, staticRenderFns } from "./ContratacaoDetalhar2.vue?vue&type=template&id=a5db6212"
import script from "./ContratacaoDetalhar2.vue?vue&type=script&lang=js"
export * from "./ContratacaoDetalhar2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports